import { Manifest } from '@/types';

const HOSTNAME_TO_SLUG: Record<string, string> = {
  // localhost
  localhost: 'sumthing',
  'sumthing.localhost': 'sumthing',
  'sumthing.preview.localhost': 'sumthing/preview',
  'greenchoice.localhost': 'greenchoice/preview',
  'biodiversityboosters.localhost': 'biodiversity-boosters/preview',
  // production
  'www.sumthing.org': 'sumthing',
  'natuurvoormorgen.greenchoice.nl': 'greenchoice',
  'foo.biodiversityboosters.nl': 'biodiversity-boosters',
  // test/preview
  'www.sumthing-preview.com': 'sumthing/preview',
  'www.sumthing-test.com': 'sumthing/preview',
  'greenchoice.sumthing.org': 'greenchoice/preview',
  'greenchoice.sumthing-preview.com': 'greenchoice/preview',
  'greenchoice.sumthing-test.com': 'greenchoice/preview',
  'biodiversityboosters.sumthing.org': 'biodiversity-boosters/preview',
  'biodiversityboosters.sumthing-preview.com': 'biodiversity-boosters/preview',
  'biodiversityboosters.sumthing-test.com': 'biodiversity-boosters/preview',
};

export async function loadManifest(
  hostname: string,
): Promise<Manifest | undefined> {
  const slug = HOSTNAME_TO_SLUG[hostname];
  if (!slug) return undefined;

  const response = await fetch(`/${slug}/manifest.json`);

  if (response.ok) {
    return await response.json();
  } else {
    return undefined;
  }
}
